import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Task } from './task.model';

@Component({
  selector: 'app-task',
  templateUrl: './task.component.html',
  styleUrls: ['./task.component.scss']
})
export class TaskComponent implements OnInit {
  @Input() task: Task;
  @Input() info: string;
  @Input() canHighlight = true;
  @Input() canDelete = false;
  @Input() highlighted = false;
  @Input() displayCogs = false;
  @Input() hasObservations = false;
  @Input() canSelect = false;
  @Input() selected = true;
  @Input() canDuplicate = false;

  @Output() delete = new EventEmitter<any>();
  @Output() toggleHighlight = new EventEmitter<any>();
  @Output() toggleSelect = new EventEmitter<any>();
  @Output() duplicate = new EventEmitter<any>();
  @Output() click = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {}

  toggleHighlighted(event: any) {
    event.preventDefault();
    event.stopPropagation();
    this.click.emit(this.task);

    if (!this.canHighlight) { return; }
    this.highlighted = !this.highlighted;
    this.toggleHighlight.emit(this.task);
  }

  onDelete(event: any) {
    event.preventDefault();
    event.stopPropagation();
    this.delete.emit(this.task);
  }

  toggleSelected(event: any) {
    event.preventDefault();
    event.stopPropagation();
    if (this.task.canStart) {
      this.toggleSelect.emit(this.task);
    }
  }

  onDuplicate(event: any) {
    event.preventDefault();
    event.stopPropagation();
    this.duplicate.emit(this.task);
  }
}
